import React from "react";
import { Redirect, Route, Switch } from "react-router-dom"

// Services
import Auth from '../auth';
import { RouteWithNavigation } from '.';

// Route Views
import Dashboard from "../views/Dashboard/Dashboard";
import DashboardLive from "../views/Dashboardlive/DashboardLive"
import Practitioners from "../views/Practitioners/Practitioners";
import DetailPractitioner from "../views/Practitioners/Profil"
import AuthenticationPractitioner from "../views/Practitioners/Authentication"
import DetailPlatformPractitioner from "../views/Practitioners/Platform"
import TransactionsPractitioner from "../views/Practitioners/Transactions"
import ConsultationsPractitioner from "../views/Practitioners/Consultations"
import Consultations from "../views/Consultations/Consultations";
import DetailConsultation from "../views/Consultations/Details";
import Callback from "../views/Auth/Callback";
import Patients from "../views/Patients/Patients";
import ProfilPatient from "../views/Patients/Profil";
import AuthenticationPatient from "../views/Patients/Authentication"
import FilesPractitioner from "../views/Practitioners/Files";
import NotFound from "../views/Errors/404";
import Statistics from "../views/Statistics/Statistics";
import Languages from "../views/Languages/Languages"
import Pharmacies from "../views/Pharmacies/Pharmacies"
import Pharmacy from "../views/Pharmacies/Pharmacy";
import GuestAuth from "../views/Auth/GuestAuth";
import PremiumMarkup from "../views/Patients/PremiumMarkup";

const auth = new Auth();

const handleAuthentication = ({location}) => {
    if (/access_token|id_token|error/.test(location.hash)) {
        auth.handleAuthentication();
    }
};

export const makeMainRoutes = () => {
    return () => (
        <Switch>
            <Route exact path="/guest/login" component={GuestAuth} />
            <RouteWithNavigation exact auth={auth} path="/dashboard-live" component={DashboardLive} />
            <RouteWithNavigation exact auth={auth} path="/dashboard" component={Dashboard} />

            {/*<PrivateRoute exact auth={auth} path="/dashboard" component={Dashboard} />*/}

            <RouteWithNavigation exact auth={auth} path="/praticiens" component={Practitioners} />
            <RouteWithNavigation exact auth={auth} path="/praticiens/:id/profil/connect" component={DetailPractitioner} />
            <RouteWithNavigation exact auth={auth} path="/praticiens/:id/profil/platform" component={DetailPlatformPractitioner} />
            <RouteWithNavigation exact auth={auth} path="/praticiens/:id/consultations" component={ConsultationsPractitioner} />
            <RouteWithNavigation exact auth={auth} path="/praticiens/:id/transactions" component={TransactionsPractitioner} />
            <RouteWithNavigation exact auth={auth} path="/praticiens/:id/fichiers" component={FilesPractitioner} />
            <RouteWithNavigation exact auth={auth} path="/praticiens/:id/authentication" component={AuthenticationPractitioner} />

            <RouteWithNavigation exact auth={auth} path="/consultations" component={Consultations} />
            <RouteWithNavigation exact auth={auth} path="/consultations/details/:id" component={DetailConsultation} />

            <RouteWithNavigation exact auth={auth} path="/patients" component={Patients} />
            <RouteWithNavigation exact auth={auth} path="/patients/:id/profil" component={ProfilPatient} />
            <RouteWithNavigation exact auth={auth} path="/patients/:id/authentication" component={AuthenticationPatient} />
{/*
            <RouteWithNavigation exact auth={auth} path="/premium/slot/patient/:id" component={PremiumMarkup} />
*/}

            <RouteWithNavigation exact auth={auth} path="/statistiques" component={Statistics} />
            <RouteWithNavigation exact auth={auth} path="/languages" component={Languages} />

            <RouteWithNavigation exact auth={auth} path="/pharmacies" component={Pharmacies} />
            <RouteWithNavigation exact auth={auth} path="/pharmacies/:id" component={Pharmacy} />


            <Route path="/callback" render={(props) => {
                handleAuthentication(props);
                return <Callback { ...props }/>
            }}/>
            <RouteWithNavigation auth={auth} component={NotFound} />
        </Switch>
    );
};


// WEBPACK FOOTER //
// ./src/router/routes.js